import PropTypes from 'prop-types';
import React from 'react';

import { displayBuyerBidState } from '../../../core/api';
import { formalDate, fromNow, fullDateTimeFormat, monthNameFormatDate, monthNameFormatDateTime } from '../../../core/date';
import BidSendMenu from './BidSendMenu';
import BidDetailPricing from './BidDetailPricing';
import BidDetailToolbar from './BidDetailToolbar';
import BidDetailNotes from './BidDetailNotes';
import AcceptBidPopUp from './AcceptBidPopUp';
import HotelDetailWithToggle from '../../../components/HotelDetail/HotelDetailWithToggle';
import HotelContact from '../../../components/HotelDetail/HotelContact';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';
import { ButtonToolbar, Button } from 'react-bootstrap';
import BidDocuments from './BidDocuments';
import { host } from "../../../config";
import axios from 'axios';
import logo from '../../../../public/new.gif';

class BidDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showDetail: false,
      is_rebid: false,
      showPopUp: false,
      showBidDocument:false,
      uploadedDocuments:[]
    };
    this.remove = this.remove.bind(this);
    this.save = this.save.bind(this);
    this.onSave = this.onSave.bind(this);
    this.openSend = this.openSend.bind(this);
    this.close = this.close.bind(this);
    this.OnClose = this.OnClose.bind(this);
  }

  matchTour(contact) {
    if (!contact.is_sent) {
      return false
    } else {
      return contact.sent_tour_ids.includes(this.props.tourData.id)
    }
  }

  componentDidMount() {
    this.fetchDocuments()
    if (this.props.bid.bidder_state == 'DD' && this.props.bid.buyer_state == 'DE') {
      this.setState({ is_rebid: true });
    }
  }

  fetchDocuments = () => {
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    const tokenKey = auth.token;
    const { tourData, bid} = this.props;

    axios.get(`${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tourData.id}&bid_id=${bid.id}`, {
        headers: {
            Authorization: `Token ${tokenKey}`,
        },
    })
        .then((response) => {
            this.setState({ uploadedDocuments: response.data });
        })
        .catch((error) => {
            console.error('Error fetching documents:', error);
        });
};


  location() {
    const bid = this.props.bid;
    let location;
    if (bid.hotel.city == null) {
      location = `${bid.hotel.state}, ${bid.hotel.country}`;
    };
    if (bid.hotel.state == null) {
      location = `${bid.hotel.city}, ${bid.hotel.country}`;
    };
    if (bid.hotel.city == null && bid.hotel.state == null) {
      location = `${bid.hotel.country}`;
    };
    if (bid.hotel.city == null && bid.hotel.state == null && bid.hotel.country == null) {
      location = '';
    };
    if (bid.hotel.city != null && bid.hotel.state != null && bid.hotel.country != null) {
      if (bid.hotel.city === bid.hotel.state) {
        location = `${bid.hotel.city}, ${bid.hotel.country}`;
      } else {
        if (bid.hotel.state === bid.hotel.country) {
          location = `${bid.hotel.city}, ${bid.hotel.country}`;
        } else {
          location = `${bid.hotel.city}, ${bid.hotel.state}, ${bid.hotel.country}`;
        }
      }
    };
    return location;
  }
  onSave(e) {
    let bids = [];
    let location = this.location();
    this.props.bids.forEach(bid => {
      if (!(this.props.bid.id == bid.id)) {
        if (bid.eventId === this.props.bid.bidset.event.id) {
          bids.push(bid);
        }
      }
    })
    if (bids.length != 0) {
      this.setState({ showPopUp: true });
    }
    const state = e.currentTarget.getAttribute('data-item');
    const payload = {};
    if (state == 'AC') {
      payload.buyer_state = state;
      if (!this.props.isTourManager) {
        payload.buyer = { id: this.props.user.id };
      }
      this.props.editBid(this.props.bid.id, payload);
    }
  }
  save(e) {
    e.preventDefault();
    const state = e.currentTarget.getAttribute('data-item');
    const payload = {};
    payload.buyer_state = state;
    if (!this.props.isTourManager) {
      // Save buyer into the bid, if not the Tour Manager.
      payload.buyer = { id: this.props.user.id };
    }
    if (payload.buyer_state === 'ST') {
      // Special case for reopen...
      payload.bidder_state = 'UR';
    }
    this.props.editBid(this.props.bid.id, payload);
  }
  remove(e) {
    e.preventDefault();
    this.props.removeBid(this.props.bid.id);
    this.close();
  }
  close() {
    this.setState({ showModal: false });
  }
  openSend() {
    this.setState({ showModal: true });
  }
  OnClose() {
    this.setState({ showPopUp: false});
  }
  copyUrl(url) {
    let copyText = url
    navigator.clipboard.writeText(copyText);
  }
  showBidDocumentModal(){
    this.setState({
      showBidDocument:true
    })
  }
  onClose(){
    this.setState({
      showBidDocument:false
    })
  }
  render() {
    const { bid } = this.props;
    const lowestCheckinDate=this.props.bidbidsDetails && this.props.bidbidsDetails[0] ? this.props.bidbidsDetails[0].bid_details.lowest_check_in_date : null
    const grestChekoutDate=this.props.bidbidsDetails && this.props.bidbidsDetails[0] ? this.props.bidbidsDetails[0].bid_details.greatest_check_out_date : null
    const hotel = bid.hotel;
    const distanceTo = { distance: bid.distance_to_venue, duration: bid.duration_to_venue };
    const bidState = displayBuyerBidState(bid.buyer_state, bid.bidder_state);
    const showBidder = bid.bidder && !this.props.isTourManager;
    const showRequestDetail = !this.props.isTourManager;
    const membersArr = this.props.bidbidsDetails;
    const datesCheckOutArr = [];
    const datesCheckInArr = [];
    const contacts = [];

    hotel.contacts.forEach(contact => {
      contacts.push(
        <div key={contact.id} >
          {contact.is_sent && this.matchTour(contact) && <HotelContact key={contact.id} hotelId={hotel.id} contact={contact} />}
        </div>
      );
    });

    for (let i = 0; i < membersArr.length; i++) {
      datesCheckInArr.push(membersArr[i].bid_details.check_in_date !== null ? membersArr[i].bid_details.check_in_date : bid.bidset.event.start);
      datesCheckOutArr.push(membersArr[i].bid_details.check_out_date !== null ? membersArr[i].bid_details.check_out_date : bid.bidset.event.end);
    }

    const uniquecheckin = [...new Set(datesCheckInArr)];
    const uniquecheckout = [...new Set(datesCheckOutArr)];
    const element = <span style={{ color: 'green' }}>Multiple Dates</span>;
    return (
      <div>
        <div className="container-fluid">
        <HotelDetailWithToggle distanceTo={distanceTo} hotel={hotel} />
        <hr style={{ margin: '30px 0 30px 0' }} />
        <div className="row">
          <div className="col-md-12">
            <h4>Bid Info ({bidState})</h4>
            <div>
            {bid.bid_url &&(
              <div style={{display:'flex'}} >
                <div>
                  <span>Bid URL:</span> &nbsp;&nbsp;<Button bsStyle="info" onClick={this.copyUrl(bid.bid_url)} title={bid.bid_url}> Copy Bid URL</Button>
                </div>
                {this.props.answers?(
                  <div style={{marginLeft:"38%"}} > 
                  <Button bsStyle="success" onClick={()=>this.showBidDocumentModal()} >View Bid Documents</Button>
                  {this.state.uploadedDocuments.length >=1&&(
                   <img style={{width:'11%',marginBottom:'20px'}} className="sidebar-img" src={logo} alt="CATCH" />
                  )}
                  </div>
                ):('')}
              </div>)}
            {bidState == 'Draft' ? (<p>Send To:</p>) : (<p>Sent To:</p>)}
            {contacts}
            <p>Replied By:</p>
              {showBidder && (
                <p>
                  {bid.name? bid.name:bid.bidder.first_name} ( {bid.email? bid.email:bid.bidder.email} )  {bid.phone_number && (bid.phone_number? bid.phone_number:'')}
                </p>
              )}
              <p>
                Stay: { monthNameFormatDate(lowestCheckinDate?lowestCheckinDate:uniquecheckin[0])} - {monthNameFormatDate(grestChekoutDate?grestChekoutDate:uniquecheckout[0])}
              </p>
              <p>
                {bid.sent_on && <span>Sent: {fromNow(bid.sent_on)} ({monthNameFormatDateTime(bid.sent_on)})</span>}
              </p>
              <p>
                {bid.replied_on && (
                  <span>Replied: {bid.replied_on && fromNow(bid.replied_on)} ({monthNameFormatDateTime(bid.replied_on)})</span>
                )}
              </p>
              <p>
                {bid.bid_accepted_on && bid.buyer_state == "AC" && (
                  <span>Bid Accepted On: {bid.bid_accepted_on && fromNow(bid.bid_accepted_on)} ({monthNameFormatDateTime(bid.bid_accepted_on)})
                   <i className="fa fa-check-circle-o" aria-hidden="true" style={{ fontSize: '24px', color: 'green', marginLeft: '8px' }}></i>
                  </span>
                )}
              </p>
            </div>
            <BidDetailPricing
              bid={this.props.bid}
              isTourManager={this.props.isTourManager}
              editBid={this.props.editBid}
              tourData={this.props.tourData}
              editMember={this.props.editMember}
              bidbidsDetails={this.props.bidbidsDetails}
              isLoading={this.props.isLoading}
              user={this.props.user}
              editGroup={this.props.editGroup}
              ChangeBidDetail={this.props.ChangeBidDetail}
              changeBidDateDetail={this.props.changeBidDateDetail}
              editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
              requestBidDetails={this.props.requestBidDetails}
              dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
              changeDateRoomType={this.props.changeDateRoomType}
              addParticipantManageBid={this.props.addParticipantManageBid}
            />
          </div>
          {this.props.answers?(
          <div className="col-md-12">
            <div className="col-md-6" >
              <h4><b>Questions Answers Details:-</b></h4>
              <ol type='1'>
              {this.props.answers.map((value)=>(
                <li>
                  <h5><b>{value.question}</b></h5>
                  <h5>{value.answer}</h5><hr style={{ margin:'0px',backgroundColor:'black' }} />
                </li>
              ))}</ol>
            </div>
            {/* <div className="col-md-6" >
              <Button bsStyle="success" onClick={()=>this.showBidDocumentModal()} >View Bid Documents</Button>
            </div> */}
          </div>):('')}
          <div className="col-md-12">
            {showRequestDetail && (
              <div>
                {this.props.bid.bidset.event.group_note && (
                  <div>
                    <h4><b>Request Details:-</b></h4>
                    <br />
                    <p>{this.props.bid.bidset.event.group_note}</p>
                    <hr />
                  </div>
                )}
                {this.props.bid.bidset.event.group_note_json.blocks? (
                  <div>
                    <h4><b>Additional Bid Details:-</b></h4>
                    <br />
                    <DraftRenderer raw={this.props.bid.bidset.event.group_note_json} />
                    <hr />
                  </div>
                ):('')}
              </div>
            )}
            <BidDetailNotes
              bid={this.props.bid}
              addBidNote={this.props.addBidNote}
              editBid={this.props.editBid}
            />
          </div>
        </div>
        {this.state.showPopUp && (
          <AcceptBidPopUp
            bid={this.props.bid}
            bids={this.props.bids}
            OnClose={this.OnClose}
            showPopUp={this.state.showPopUp}
            editBid={this.props.editBid}
            user={this.props.user}
            isTourManager={this.props.isTourManager}

            />
          )}
          {!this.props.readOnly && (
            <BidDetailToolbar
              bid={this.props.bid}
              isHide={this.props.isHide}
              open={this.open}
              remove={this.remove}
              save={this.save}
              onSave={this.onSave}
              openSend={this.openSend}
              isTourManager={this.props.isTourManager}
            />
          )}
          {this.state.showBidDocument && (
            <BidDocuments 
              tourData={this.props.tourData}
              bid={this.props.bid}
              show={this.state.showBidDocument}
              onClose={()=>this.onClose()}
            />
          )}
          <BidSendMenu
            bid={this.props.bid}
            close={this.close}
            show={this.state.showModal}
            sendBid={this.props.sendBid}
            sendHotelBidRequests={this.props.sendHotelBidRequests}
            is_rebid={this.state.is_rebid}
          />
        </div>
      </div>
    );
  }
}

BidDetail.propTypes = {
  bid: PropTypes.object.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
  user: PropTypes.object.isRequired,
  changeDateRoomType: PropTypes.func,
};

export default BidDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetail.js